module.exports = __webpack_public_path__ + "img/lw-our-work.32aa0cf9.jpg";